const GRADIENT_ID = 'catalog-item-details-sparkle-gradient'

export const CatalogItemDetailsSparkle = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <defs>
      <linearGradient
        id={GRADIENT_ID}
        x1='4'
        y1='4'
        x2='20'
        y2='20'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#002E33' />
        <stop offset='1' stopColor='#008A99' />
      </linearGradient>
    </defs>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20C12.3842 20 12.6957 19.6885 12.6957 19.3043C12.6957 15.6545 15.6545 12.6957 19.3043 12.6957C19.6885 12.6957 20 12.3842 20 12C20 11.6158 19.6885 11.3043 19.3043 11.3043C15.6545 11.3043 12.6957 8.34553 12.6957 4.69565C12.6957 4.31145 12.3842 4 12 4C11.6158 4 11.3043 4.31145 11.3043 4.69565C11.3043 8.34553 8.34553 11.3043 4.69565 11.3043C4.31145 11.3043 4 11.6158 4 12C4 12.3842 4.31145 12.6957 4.69565 12.6957C8.34553 12.6957 11.3043 15.6545 11.3043 19.3043C11.3043 19.6885 11.6158 20 12 20Z'
      fill={`url(#${GRADIENT_ID})`}
    />
  </svg>
)
